<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Accreditati',
      link: '/accreditati'
    }, {
      label: form.uuid ? 'Modifica Accreditato' : 'Aggiungi nuovo Accreditato'
    }]"
  />
  <form autocomplete="off">
    <InputText
      v-model="form.name"
      :error-fields="errorFields"
      name="name"
      :submitted="submitted"
    >
      Nome
    </InputText>

    <InputText
      v-model="form.address"
      :error-fields="errorFields"
      name="address"
      :submitted="submitted"
    >
      Indirizzo
    </InputText>

    <InputText
      v-model="form.city"
      :error-fields="errorFields"
      name="city"
      :submitted="submitted"
    >
      Città
    </InputText>

    <InputText
      v-model="form.zip"
      :error-fields="errorFields"
      name="zip"
      :submitted="submitted"
    >
      CAP
    </InputText>

    <InputText
      v-model="form.province"
      :error-fields="errorFields"
      name="province"
      :submitted="submitted"
    >
      Provincia
    </InputText>

    <InputText
      v-model="form.country"
      :error-fields="errorFields"
      name="country"
      :submitted="submitted"
    >
      Nazione
    </InputText>

    <InputBoolean
      v-model="form.disabled"
      :error-fields="errorFields"
      name="disabled"
      :submitted="submitted"
    >
      Disabilitata
    </InputBoolean>

    <InputText
      v-model="form.accountingCode"
      :error-fields="errorFields"
      name="accountingCode"
      :submitted="submitted"
    >
      Codice contabilità
    </InputText>

    <InputTextarea
      v-model="form.notes"
      :error-fields="errorFields"
      name="notes"
      :submitted="submitted"
    >
      Note
    </InputTextarea>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive } from 'vue'

import InputBoolean from '@/components/form/InputBoolean.vue';
import InputText from '@/components/form/InputText.vue';
import InputTextarea from '@/components/form/InputTextarea.vue';
import SubmitButtons from '@/components/form/SubmitButtons.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import useAxios from '@/composables/axios';
import useForm from '@/composables/form';

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  }
})

const axios = useAxios()

let form = reactive({ 
  name: '',
  address: '',
  city: '',
  zip: '',
  province: '',
  country: '',
  notes: ''
})

if (props.id) {
  const resp = await axios.get('/affiliate/' + props.id);
  form = reactive(resp.data)
}

const rules = {
  name: {
    type: 'string',
    max: 64,
    required: true
  },
  address: {
    type: 'string',
    max: 64
  },
  city: {
    type: 'string',
    max: 64
  },
  zip: {
    type: 'string',
    max: 64
  },
  province: {
    type: 'string',
    max: 64
  },
  country: {
    type: 'string',
    max: 64,
    required: true
  },
  accountingCode: {
    type: 'string',
    max: 36
  },
  
}
const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'affiliate', rules, {
  create: 'Accreditato creato con successo',
  update: 'Accreditato modificato con successo'
}, '/accreditati', () => {
  form.name = '';
  form.accountingCode = ''
  form.notes = '';
})

</script>
   
